import { render } from "./rightBar.vue?vue&type=template&id=56e833e0"
import script from "./rightBar.vue?vue&type=script&lang=js"
export * from "./rightBar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__